import { render, staticRenderFns } from "./BespokeTheBlackList.vue?vue&type=template&id=6d936476&scoped=true&"
import script from "./BespokeTheBlackList.vue?vue&type=script&lang=js&"
export * from "./BespokeTheBlackList.vue?vue&type=script&lang=js&"
import style0 from "./BespokeTheBlackList.vue?vue&type=style&index=0&id=6d936476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d936476",
  null
  
)

export default component.exports